import React from 'react';

export default function RuahanLabelSticker({
  brandName = '',
  variantName = '',
  ukuran = '',
  tanggal = '',
  labelTag = 'Ruahan',
  scale = 1
}) {
  const goldenColor = '#000000';

  const toTitleCase = (str) => {
    if (!str) return '';
    return String(str)
      .toLowerCase()
      .replace(/\b\w/g, s => s.toUpperCase());
  };

  const cleanBrand = toTitleCase(brandName || 'Brand');
  const cleanVariant = toTitleCase(variantName || 'Varian');
  const cleanUkuran = ukuran || '';
  const cleanTanggal = tanggal || '';

  const hasUkuran = Boolean(cleanUkuran);
  const textLen = cleanVariant.length;

  let variantFontSize = '5.5pt';
  let variantLineHeight = 1.1;
  let variantLineClamp = hasUkuran ? 2 : 3;

  if (hasUkuran) {
    if (textLen > 32) {
      variantFontSize = '4.2pt';
      variantLineHeight = 1.05;
    } else if (textLen > 20) {
      variantFontSize = '4.8pt';
      variantLineHeight = 1.08;
    } else {
      variantFontSize = '5.5pt';
    }
  } else {
    if (textLen > 40) {
      variantFontSize = '4.4pt';
      variantLineHeight = 1.05;
      variantLineClamp = 3;
    } else if (textLen > 24) {
      variantFontSize = '5.0pt';
      variantLineHeight = 1.08;
      variantLineClamp = 3;
    } else {
      variantFontSize = '5.5pt';
      variantLineClamp = 2;
    }
  }

  return (
    <div 
      className="bg-white border border-black box-border relative overflow-hidden shrink-0" 
      style={{ 
        width: '40mm', 
        height: '20mm', 
        fontFamily: '"Poppins", sans-serif',
        transform: scale !== 1 ? `scale(${scale})` : undefined,
        transformOrigin: 'top left',
      }}
    >
      {/* Content Container */}
      <div className="relative z-10 w-full h-full pt-[1mm] pb-[1mm] px-[1.5mm] flex flex-col">
        
        {/* Header Section */}
        <div className="flex items-center gap-[1.5mm] mb-[0.5mm] w-full shrink-0">
          {/* Logo */}
          <div className="flex items-center justify-center shrink-0 w-[4.5mm] h-[4.5mm]">
            <img src="/logo hitam sde.png" alt="Logo" className="w-full h-full object-contain object-left" />
          </div>
          {/* Company & Address */}
          <div className="flex flex-col justify-center flex-1 pb-[0.2mm]">
            <span style={{ color: goldenColor, fontSize: '4.76pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1.1 }}>
              PT. Satala Dermatech Essential
            </span>
            <span style={{ color: goldenColor, fontSize: '2.5pt', fontStyle: 'italic', fontWeight: 400, lineHeight: 1.1, marginTop: '0.2mm' }}>
              Jl.Aster Kav, Paspampres Kota Batu, Kab. Bogor, Jawa Barat
            </span>
          </div>
        </div>

        {/* Divider Line */}
        <div className="shrink-0" style={{ height: '0.4pt', backgroundColor: goldenColor, width: '100%', marginBottom: '0.8mm' }} />

        {/* Body Section */}
        <div className="flex-1 relative w-full flex flex-col overflow-hidden">
          
          <div className="flex-1 flex flex-col items-center justify-center w-full px-[1.5mm]">
            <span style={{ color: goldenColor, fontSize: '4.5pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1, textAlign: 'center' }}>
              {cleanBrand}
            </span>
            <span 
              style={{ 
                color: goldenColor, 
                fontSize: variantFontSize, 
                fontWeight: 600, 
                fontStyle: 'italic', 
                lineHeight: variantLineHeight, 
                margin: '0.3mm 0', 
                textAlign: 'center', 
                wordBreak: 'break-word', 
                display: '-webkit-box', 
                WebkitLineClamp: variantLineClamp, 
                WebkitBoxOrient: 'vertical', 
                overflow: 'hidden' 
              }}
            >
              {cleanVariant}
            </span>
            
            {/* Tampilkan ukuran di bawah nama varian */}
            {cleanUkuran && (
              <span style={{ color: goldenColor, fontSize: '4pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1, textAlign: 'center', marginTop: '0.3mm' }}>
                {cleanUkuran}
              </span>
            )}
          </div>

          <div className="w-full flex items-end mt-auto pb-[0.2mm] px-[1.5mm] shrink-0">
            <div className="flex-1" />
            <span className="flex-none text-center" style={{ color: goldenColor, fontSize: '4.76pt', fontWeight: 600, fontStyle: 'italic', lineHeight: 1 }}>
              {cleanTanggal}
            </span>
            <div className="flex-1 flex justify-end">
              <span style={{ color: goldenColor, fontSize: '4.5pt', fontStyle: 'italic', fontWeight: 700, lineHeight: 1 }}>
                {labelTag}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
